import React, { Component } from 'react';
import Show from '../components/health/NotificationSafety/Show'
import WebpackerReact from 'webpacker-react';

class NotificationSafetyShow extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: false,
        }
    }

    componentDidMount(){
        this.loadTasks();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
            isLoaded: false
        })

    }

    //add update
    updateItem = task => {
        console.log("updateItemupdateItemupdateItem")
        this.setState({
            data: this.state.data.map(item => {
            if (task.id === item.id) {
              return { ...item, 
                description: task.description,
                due_date: task.due_date,
                name: task.name,
                state: task.state,
                user_owner: task.user_owner,
                general_comments: task.general_comments.length,
                general_files: task.general_files.length,
                task_labels: task.task_labels,
                users: task.task_labels,
                checklist: task.checklist,
              }
            }
            return item;
          })
        });
    }

    loadTasks = () => {
        fetch(`/task/get_module_task/${this.props.safety_notification.module_task_id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }

    render() {
        return (
            <React.Fragment>
                <Show
                    updateStateLoad={this.updateStateLoad}
                    isLoaded={this.state.isLoaded}
                    event_notification={this.props.safety_notification}
                    data={this.state.data}

                    loadTasks={this.loadTasks}
                    user={this.props.user} 
                    users={this.props.users} 
                    estados={this.props.estados}

                    updateData={this.updateData}
                    updateItem={this.updateItem}
                    procesos={this.props.procesos}
                    task_source={this.props.task_source}
                />
            </React.Fragment>
        );
    }
}


export default NotificationSafetyShow;
WebpackerReact.setup({ NotificationSafetyShow });
